import { Badge, Box, IconButton, styled } from "@mui/material"
import { Stack } from "src/shared/components"
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined"
import sidebarIcon from "src/assets/icons/sidebar.png"
import { useLocation } from "react-router-dom"
import { getBreadcrumbItems } from "src/shared/utils/breadcrums"
import Breadcrumbs from "src/shared/components/breadcrums"
import { memo } from "react"

// Types
interface NavbarProps {
  toggleSidebar: () => void
}

// Styled Components
const IconImage = styled("img")(({ theme }) => ({
  width: "20px",
  filter: theme.palette.mode === "dark" ? "invert(1)" : "invert(0)"
}))

// Components
const NotificationButton = memo(() => (
  <IconButton>
    <Badge color="secondary" badgeContent={0} showZero>
      <NotificationsActiveOutlinedIcon />
    </Badge>
  </IconButton>
))

const BreadcrumbsSection = memo(() => {
  const location = useLocation()
  const breadcrumbs = getBreadcrumbItems(location.pathname).slice(1)

  if (!breadcrumbs.length) return null

  return (
    <Stack
      sx={{
        ml: 1,
        pl: 1,
        borderLeft: (theme) => `2px solid ${theme.palette.divider}`
      }}
    >
      <Breadcrumbs items={breadcrumbs} />
    </Stack>
  )
})

// Main Component
const Navbar = memo(({ toggleSidebar }: NavbarProps) => {
  return (
    <Stack overflow="hidden" px={2} direction="row" alignItems="center" height="70px">
      <IconButton onClick={toggleSidebar}>
        <IconImage src={sidebarIcon} alt="sidebar toggle" />
      </IconButton>

      <BreadcrumbsSection />

      <Box sx={{ flexGrow: 1 }} />

      <Stack direction="row" alignItems="center" spacing={2}>
        <NotificationButton />
      </Stack>
    </Stack>
  )
})

Navbar.displayName = "Navbar"
NotificationButton.displayName = "NotificationButton"
BreadcrumbsSection.displayName = "BreadcrumbsSection"

export default Navbar
